
import React from "react";

import {
  Button,
  Dialog,
  Classes,
  Intent,
  Callout,
  Card,
  FormGroup,
  InputGroup,
  H3,
  Tooltip
} from "@blueprintjs/core";
import { Trans } from "react-i18next";

import { authenticatedPostFetchWithResult } from "../../utils/AuthenticatedFetch";

export default class PasswordChanger extends React.Component {
  constructor() {
    super();
    this.state = {
      isOpen: false,
      loading: false,
      pwdOld: "",
      n1: "",
      n2: "",
      errPwdCurrent: false,
      errPwdSpecial: false,
      errPwdLength: false,
      errPwdOld: false,
      showPassword: false,
      success: false
    }
  }

  handleOpen = () => this.setState({ isOpen: true });
  handleClose = () => this.setState(
    {
      isOpen: false,
      loading: false,
      pwdOld: "",
      n1: "",
      n2: "",
      useTallContent: false,
      errPwdCurrent: false,
      errPwdSpecial: false,
      errPwdLength: false,
      errPwdOld: false,
      showPassword: false,
      success: false
    });

  handlePasswordChange = async () => {
    this.setState({ loading: true });

    authenticatedPostFetchWithResult('/changpwd',
      {
        old: this.state.pwdOld,
        new1: this.state.n1,
        new2: this.state.n2
      },
      (status, response) => {
        if (status === 200) {
          this.setState({
            success: true,
            errPwdCurrent: false,
            errPwdSpecial: false,
            errPwdLength: false,
            errPwdOld: false
          });
        } else {
          this.setState({
            errPwdOld: response.includes("bad old password"),
            errPwdMissmatch: response.includes("new passwords missmatch"),
            errPwdSpecial: response.includes("new password not enough special char"),
            errPwdLength: response.includes("new password too short")
          });
        }
        this.setState({ loading: false });
      });
  };

  handleLockClick = () => {
    this.setState({ showPassword: !this.state.showPassword });
  }

  render() {
    const lockButton = (
      <Tooltip key="lb" content={this.state.showPassword ? <Trans>hide password</Trans> : <Trans>show password</Trans>}>
        <Button
          icon={this.state.showPassword ? "unlock" : "lock"}
          intent={Intent.WARNING}
          minimal={true}
          onClick={this.handleLockClick}
        />
      </Tooltip>
    );

    return (
      <div>
        <Button
          onClick={this.handleOpen}
          icon="key"
          text={<Trans>change password</Trans>}
        />
        <Dialog onClose={this.handleClose} isOpen={this.state.isOpen} style={{ transition: 'none' }}>
          <div className={Classes.DIALOG_BODY}>
            <H3><Trans>change password</Trans></H3>

            <Callout intent="warning"><Trans>this operation is irreversible</Trans></Callout>
            <Callout hidden={!this.state.errPwdOld} intent="danger"><Trans>current password is incorrect</Trans></Callout>
            <Callout hidden={!this.state.errPwdSpecial} intent="danger"><Trans>your new password must contain at least 1 special character</Trans></Callout>
            <Callout hidden={!this.state.errPwdLength} intent="danger"><Trans>your new password must contain at least 8 characters</Trans></Callout>
            <br />
            <div className={Classes.DIALOG_FOOTER} hidden={!this.state.success}>
              <Callout intent="success"><Trans>password modified successfully</Trans></Callout>
              <div className={Classes.DIALOG_FOOTER_ACTIONS}>
                <br />
                <Button icon='undo' intent={Intent.DANGER} disabled={this.state.loading} onClick={this.handleClose} />
              </div>
            </div>
            <div className={Classes.DIALOG_FOOTER} hidden={this.state.success}>
              <Card>
                <form>
                  <FormGroup label={<Trans>old password</Trans>} labelFor="login-input">
                    <InputGroup id="login-input"
                      onChange={(ti) => { this.setState({ pwdOld: ti.target.value }); }}
                      rightElement={lockButton}
                      intent={this.state.errPwdOld ? "danger" : "normal"}
                      type={this.state.showPassword ? "text" : "password"}
                    />
                  </FormGroup>
                  <FormGroup label={<Trans>new password</Trans>} labelFor="password-input">
                    <InputGroup
                      id="password-input"
                      type={this.state.showPassword ? "text" : "password"}
                      onChange={(ti) => { this.setState({ n1: ti.target.value }); }}
                      rightElement={lockButton}
                      intent={
                        (this.state.errPwdSpecial
                          || this.state.errPwdLength
                          || this.state.errPwdMissmatch
                        )
                          ? "danger" : "normal"}
                    />
                  </FormGroup>
                  <FormGroup label={<Trans>new password again</Trans>} labelFor="password-input">
                    <InputGroup
                      id="password-input"
                      type={this.state.showPassword ? "text" : "password"}
                      onChange={(ti) => { this.setState({ n2: ti.target.value }); }}
                      rightElement={lockButton}
                      intent={
                        (this.state.errPwdSpecial
                          || this.state.errPwdLength
                          || this.state.errPwdMissmatch
                        )
                          ? "danger" : "normal"}
                    />
                  </FormGroup>
                </form>
              </Card>
              <br />
              <div className={Classes.DIALOG_FOOTER_ACTIONS}>
                <Button icon='undo' intent={Intent.DANGER} disabled={this.state.loading} onClick={this.handleClose} >
                  <Trans>cancel</Trans>
                </Button>
                <Button icon='upload' loading={this.state.loading} onClick={this.handlePasswordChange}>
                  <Trans>send</Trans>
                </Button>
              </div>
            </div>
          </div>
        </Dialog >
      </div>
    );
  }
}